import * as React from "react"
import {Link as RouterLink} from "react-router-dom"
import {Link} from "@mui/material"
import {ButtonSeeker} from "@ui-seeker/core"

import {REPRICING_ROUTES} from "@constants"

export default function RepricingCreateButton() {
    return <Link component={RouterLink} to={REPRICING_ROUTES.FORM_PATH}>
        <ButtonSeeker sx={{ px: 3 }}>
            Create new rule
        </ButtonSeeker>
    </Link>
}